import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  newAddressButton: {
    marginLeft: 'auto',
    display: 'flex',
    marginBottom: theme.spacing(2),
    width: 'fit-content',
  },
  chip: {
    backgroundColor: theme.palette.neutral.lightest,
    color: theme.palette.neutral.dark,
    display: 'flex',
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  radiosContainer: { margin: theme.spacing(2, 0) },
  deleteIcon: { cursor: 'pointer' },
  radioWrapper: {
    position: 'relative',
    paddingRight: theme.spacing(3),
    maxWidth: '600px',

    alignItems: 'center',
    display: 'flex',

    '&:hover': {
      backgroundColor: theme.palette.neutral.lightest,
      '& $iconButton': {
        display: 'grid',
        placeItems: 'center',
        pointerEvents: 'initial',
      },
    },

    '&.is-checked, &:hover': {
      backgroundColor: theme.palette.neutral.lightest,
      '& $chip': {
        backgroundColor: theme.palette.neutral.white,
      },
    },
  },
  radio: {
    padding: theme.spacing(1),
    marginBottom: 0,
    maxWidth: '425px',

    '&:hover .MuiRadio-root': {
      color: theme.palette.primary.main,
    },
  },
}))

export default useStyles
